
interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export class Nav {
  public navItems: NavData[] = [
    {
      name: 'Dashboard',
      url: 'dashboard',
      icon: 'home'
    },
    {
      name: 'Incoming / Outgoing',
      url: 'incoming-outgoing-vehicles',
      icon: 'directions'
    },
    {
      name: 'Sensors',
      url: 'sensors',
      icon: 'wifi_tethering'
    },
    {
      name: 'Sensor Groups',
      url: 'groups',
      icon: 'view_comfy'
    },
    {
      name: 'Menu-Notifications',
      url: 'all-notifications',
      icon: 'notifications'
    },
    {
      name: 'Rules',
      url: 'rules',
      icon: 'rule'
    },
    {
      name: 'Map',
      url: 'map',
      icon: 'map'
    },
    {
      name: 'Policing',
      url: 'policing',
      icon: 'local_car_wash',
      children: [{
        name: 'Violations',
        url: 'policing/violations',
        icon: 'local_police'
      },
      {
        name: 'Disputes',
        url: 'policing/disputes',
        icon: 'announcement'
      },
      {
        name: 'Resident Management',
        url: 'policing/residents',
        icon: 'assignment'
      },
      {
        name: 'Pricing Policy',
        url: 'pricing',
        icon: 'monetization_on'
      },
      ]
    },
    {
      name: 'User Management',
      url: 'users-management/all-users',
      icon: 'person'
    },
    {
      name: 'Booking',
      url: 'booking',
      icon: 'book',
      children: [{
        name: 'Transactions',
        url: 'booking/transactions',
        icon: ''
      }],
    },    
    {
      name: 'Account',
      url: 'account',
      icon: 'settings'
    },
    {
      name: 'Contact',
      url: 'contact',
      icon: 'contact_mail'
    },
    {
      name: 'Logout',
      url: 'logout',
      icon: 'exit_to_app'
    }
  ];
}
